/* eslint-disable no-unused-vars */
import { detectFaces } from "./faceLandmarker";

const imageValidation = async (img, direction, width, height) => {
    let validations = [false, false, false, false, false, false]; // 0 --> Gaze direction, 1 --> Distance, 2 --> Blink, 3 --> Lighting 4 --> Eye Size 5 --> Out Bound
    let distanceThreshold = img.width > img.height ? 0.85 : 2.0;
    const predictions = await detectFaces(img); // Refresh bug culprit here...

    if (predictions.faceLandmarks && predictions.faceLandmarks.length === 1) {
        let keypoints = [];
        for(let i=0; i<predictions.faceLandmarks[0].length; i++) {
            keypoints.push({
                x: predictions.faceLandmarks[0][i].x * img.width,
                y: predictions.faceLandmarks[0][i].y * img.height
            })
        }

        let allFace = [];
        allFace.push([keypoints[10].x, keypoints[10].y]);
        allFace.push([keypoints[454].x, keypoints[454].y]);
        allFace.push([keypoints[152].x, keypoints[152].y]);
        allFace.push([keypoints[234].x, keypoints[234].y]);

        // Check light
        validations[3] = calculateBrightness(img, allFace);

        const [xri, yri] = [keypoints[468].x, keypoints[468].y, keypoints[468].z];
        const [xlc1] = [keypoints[362].x, keypoints[362].y, keypoints[362].z];
        const [xlc2] = [keypoints[263].x, keypoints[263].y, keypoints[263].z];
        const [xli, yli] = [keypoints[473].x, keypoints[473].y, keypoints[473].z];
        const [xrc1] = [keypoints[33].x, keypoints[33].y, keypoints[33].z];
        const [xrc2] = [keypoints[133].x, keypoints[133].y, keypoints[133].z];

        const [xrui, yrui] = [keypoints[469].x, keypoints[469].y, keypoints[469].z];
        const [xrri, yrri] = [keypoints[470].x, keypoints[470].y, keypoints[470].z];
        const [xrdi, yrdi] = [keypoints[471].x, keypoints[471].y, keypoints[471].z];
        const [xrli, yrli] = [keypoints[472].x, keypoints[472].y, keypoints[472].z];


        const [xlui, ylui] = [keypoints[474].x, keypoints[474].y, keypoints[474].z];
        const [xlri, ylri] = [keypoints[475].x, keypoints[475].y, keypoints[475].z];
        const [xldi, yldi] = [keypoints[476].x, keypoints[476].y, keypoints[476].z];
        const [xlli, ylli] = [keypoints[477].x, keypoints[477].y, keypoints[477].z];

        const radiusLeft = (Math.sqrt((xli - xlui) * (xli - xlui) + (yli - ylui) * (yli - ylui)) +
            Math.sqrt((xli - xlri) * (xli - xlri) + (yli - ylri) * (yli - ylri)) +
            Math.sqrt((xli - xldi) * (xli - xldi) + (yli - yldi) * (yli - yldi)) +
            Math.sqrt((xli - xlli) * (xli - xlli) + (yli - ylli) * (yli - ylli))) / 4;

        const radiusRight = (Math.sqrt((xri - xrui) * (xri - xrui) + (yri - yrui) * (yri - yrui)) +
            Math.sqrt((xri - xrri) * (xri - xrri) + (yri - yrri) * (yri - yrri)) +
            Math.sqrt((xri - xrdi) * (xri - xrdi) + (yri - yrdi) * (yri - yrdi)) +
            Math.sqrt((xri - xrli) * (xri - xrli) + (yri - yrli) * (yri - yrli))) / 4;

        let right = false;
        let left = false;
        let up = false;
        let center = false;
        let upcenter =false;

        let rightDistanceRatio = Math.abs(Math.abs(xrc2 - xri) - Math.abs(xrc1 - xri)) / Math.abs(xrc2 - xrc1);
        let leftDistanceRatio = Math.abs(Math.abs(xlc2 - xli) - Math.abs(xlc1 - xli)) / Math.abs(xlc2 - xlc1);

        if (rightDistanceRatio < 0.2 && leftDistanceRatio < 0.2){
            center = true;
        }
        else {
            if (Math.abs(xli - xlc1)<Math.abs(xli - xlc2) || Math.abs(xri - xrc1)<Math.abs(xri - xrc2)){
                right = true;
            }
            if (Math.abs(xli - xlc1)>Math.abs(xli - xlc2) || Math.abs(xri - xrc1)>Math.abs(xri - xrc2)){
                left = true;
            }
        }

        if (rightDistanceRatio < 0.2 && leftDistanceRatio < 0.2){
            upcenter = true;
        }

        let cencoeffs = [42.87794129, -45.72376787, 29.61333983, -45.53869072, -6.442634106, -20.18497742, -5.286660462, -2.929316781, -33.64631808, 17.90925384, -26.11967638, 7.182034318, -26.99068402, -8.045325557, 1.706551651, -9.111674908, 25.18706196, -27.45087698, 19.00463309, -20.35332101, -13.74168561, -35.3641274, -39.74538847, -13.22129902, -22.55908169, 43.41212713, -5.674922973, 45.58726721, 7.736146756, 23.75569002, 37.64893105, -10.69813477, -1.113930452, 15.5866387, 116.2155854, 27.02035624, 22.32056134, 27.56853688, -105.8757025, 13.73694915, 0.564971301, 26.33885566, -29.24653294, -33.91898485, -34.04897502, -32.15605893, 10.64659901, -44.40544592, 14.42230059, 10.99859376, 22.65037703, 33.74344229, 28.06941774, 20.33435173, -0.209615014, 13.50867602, -26.69770848, -43.06961664, -50.78655957, -61.75714885, -17.19790926, 3.88718674, -7.118519346, 24.60770283, 16.48334634, 59.14593038, 49.15369747, 34.64350888, 41.95898193, 1.716340032, 21.22616843, -12.66495241, -24.15785557, -24.44738836, -24.24290303, -1.16320441, 99.22651984, -0.845852067, 0.969363823, 28.3844841, -111.1025741, 28.72876438, 4.269686563, -13.11046571]
        let rcoeffs = [-16.12585742, -13.06401445, -30.20932905, -16.56818202, 7.559179918, -18.86645849, 52.2811122, 41.32228319, 38.10326565, -1.270254522, 17.4047389, 24.46297884, 20.22534134, 16.60374973, -5.665125606, 9.711622367, -12.84547257, -1.436236899, 8.313465491, -31.42904662, -31.19267223, -11.88260658, 14.57147151, -7.709829531, 17.75505801, -8.62304666, 11.20639384, -7.447225436, 21.74310659, 29.80926059, -8.194273835, 3.313837928, 0.070889779, -11.66017153, -116.8797443, 11.52706547, -43.87932014, -12.81090674, 47.84480819, 10.7731909, 5.65572508, -6.727330581, 31.01861605, -8.566990924, 26.60619666, -16.60798086, -8.173436594, 22.39628156, 15.31859195, 13.00835188, -5.874608417, 12.54287437, 4.494597384, 37.8259332, 11.66481374, 30.56412121, 25.68378028, -27.6948502, 36.44814648, -43.64993386, 11.43910633, -19.01668439, 30.1161269, -4.140384105, 31.46909512, -20.73353564, -19.30862654, -8.112551744, -8.933961554, -6.952376753, 16.79908778, 15.62293743, 9.044991613, -3.730752391, -59.67988009, 26.07581618, -29.62969789, -1.655431276, -2.495310805, -56.44466986, -63.2133378, 8.847092862, -56.73257359, 54.97127934]
        let lcoeffs = [-30.38651183, -7.456301632, -23.82285352, -21.62544441, -29.12033621, -9.792040904, 5.484480679, -12.87244882, 7.349404248, -5.185140519, 17.23675989, 4.899511277, -29.81171115, -12.112746, 30.55633386, -31.44775414, -5.460917583, -3.14928083, -8.351659381, 3.484554003, -15.84375183, -0.209150495, -50.52762426, 32.55533599, 1.204473123, 39.22765387, 10.53343919, -25.74341324, -9.296908587, 14.83858205, -36.87764674, -9.886301414, 57.55837139, 18.305926, 39.44132247, -9.388969952, 18.04290674, -1.500120064, 42.09883794, 6.030678246, 15.13799401, 50.847216, 33.33443556, -16.13012234, -23.87077616, -5.237215379, 15.86278893, 11.53833588, 1.615849217, 54.16379233, -8.503526598, 19.06189736, -35.71522779, 38.66137261, -29.97015979, -28.86726541, 0.410119229, 16.40316328, -1.191408323, 29.45547957, 37.50691376, -6.50287893, -29.3491678, 11.02274037, -8.535532235, 11.87100522, -8.881490883, -50.60298241, -4.620720182, -10.48140631, -67.23798603, -31.54858734, -3.661662987, -13.30874069, 15.44902396, -8.144030239, -48.66320575, 7.879082741, -9.203436725, 4.024396735, 134.6628365, -52.75768729, 40.15403982, 2.331535441]
        let upcoeffs = [23.18126227, -7.410962677, 31.04423731, 21.80073729, 18.54853397, 21.85376968, -22.70088019, 13.17542632, -36.86262456, 13.82757714, -65.67220174, -0.515358497, -77.16874172, 20.68328064, -18.99380811, 17.40559696, -4.344432535, 20.38152956, 0.542949879, 2.064224142, -1.034531417, -0.069362732, 20.65155543, -24.52370151, 27.12970526, -10.39101726, 26.55326123, 16.86345732, 33.27701728, -2.907181641, 35.58910145, 8.76077343, -11.39058508, -12.90290193, 80.35771901, -19.31433064, 4.340268147, -23.37229521, -66.70126935, -16.36096108, -37.49113932, -51.26082885, -6.830296467, 20.34147872, 31.11957443, 16.92424097, 33.13217666, 4.152338297, 37.5198735, -22.09911867, 33.32859587, -23.41898236, 6.094886667, -31.97432725, -2.642719014, -15.96712173, -38.49053733, -4.703895397, -26.24665189, 3.434808054, -20.5536665, 26.7904553, -19.63656168, 54.49152461, -7.250970914, 41.05446249, -4.93172746, 23.40412735, -9.111776978, 1.57118286, 7.38287908, 2.979680206, 4.580034885, 9.448608935, 5.288836351, -9.399953356, 58.29712376, -27.93862248, 8.038926703, 20.41682158, -54.58723794, -14.80772347, 7.623991498, -66.12428565]
        let dfeatures = [parseFloat((keypoints[33].x / img.width).toFixed(2)), parseFloat((keypoints[33].y / img.height).toFixed(2)), parseFloat((keypoints[246].x/img.width).toFixed(2)), parseFloat((keypoints[246].y/img.height).toFixed(2)), parseFloat((keypoints[161].x/img.width).toFixed(2)), parseFloat((keypoints[161].y/img.height).toFixed(2)), parseFloat((keypoints[160].x/img.width).toFixed(2)), parseFloat((keypoints[160].y/img.height).toFixed(2)), parseFloat((keypoints[159].x/img.width).toFixed(2)), parseFloat((keypoints[159].y/img.height).toFixed(2)), parseFloat((keypoints[158].x/img.width).toFixed(2)), parseFloat((keypoints[158].y/img.height).toFixed(2)), parseFloat((keypoints[157].x/img.width).toFixed(2)), parseFloat((keypoints[157].y/img.height).toFixed(2)), parseFloat((keypoints[173].x/img.width).toFixed(2)), parseFloat((keypoints[173].y/img.height).toFixed(2)), parseFloat((keypoints[133].x/img.width).toFixed(2)), parseFloat((keypoints[133].y/img.height).toFixed(2)), parseFloat((keypoints[155].x/img.width).toFixed(2)), parseFloat((keypoints[155].y/img.height).toFixed(2)), parseFloat((keypoints[154].x/img.width).toFixed(2)), parseFloat((keypoints[154].y/img.height).toFixed(2)), parseFloat((keypoints[153].x/img.width).toFixed(2)), parseFloat((keypoints[153].y/img.height).toFixed(2)), parseFloat((keypoints[145].x/img.width).toFixed(2)), parseFloat((keypoints[145].y/img.height).toFixed(2)), parseFloat((keypoints[144].x/img.width).toFixed(2)), parseFloat((keypoints[144].y/img.height).toFixed(2)), parseFloat((keypoints[163].x/img.width).toFixed(2)), parseFloat((keypoints[163].y/img.height).toFixed(2)), parseFloat((keypoints[7].x/img.width).toFixed(2)), parseFloat((keypoints[7].y/img.height).toFixed(2)), parseFloat((keypoints[468].x/img.width).toFixed(2)), parseFloat((keypoints[468].y/img.height).toFixed(2)), parseFloat((keypoints[469].x/img.width).toFixed(2)), parseFloat((keypoints[469].y/img.height).toFixed(2)), parseFloat((keypoints[470].x/img.width).toFixed(2)), parseFloat((keypoints[470].y/img.height).toFixed(2)), parseFloat((keypoints[471].x/img.width).toFixed(2)), parseFloat((keypoints[471].y/img.height).toFixed(2)), parseFloat((keypoints[472].x/img.width).toFixed(2)), parseFloat((keypoints[472].y/img.height).toFixed(2)), parseFloat((keypoints[362].x/img.width).toFixed(2)), parseFloat((keypoints[362].y/img.height).toFixed(2)), parseFloat((keypoints[398].x/img.width).toFixed(2)), parseFloat((keypoints[398].y/img.height).toFixed(2)), parseFloat((keypoints[384].x/img.width).toFixed(2)), parseFloat((keypoints[384].y/img.height).toFixed(2)), parseFloat((keypoints[385].x/img.width).toFixed(2)), parseFloat((keypoints[385].y/img.height).toFixed(2)), parseFloat((keypoints[386].x/img.width).toFixed(2)), parseFloat((keypoints[386].y/img.height).toFixed(2)), parseFloat((keypoints[387].x/img.width).toFixed(2)), parseFloat((keypoints[387].y/img.height).toFixed(2)), parseFloat((keypoints[388].x/img.width).toFixed(2)), parseFloat((keypoints[388].y/img.height).toFixed(2)), parseFloat((keypoints[466].x/img.width).toFixed(2)), parseFloat((keypoints[466].y/img.height).toFixed(2)), parseFloat((keypoints[263].x/img.width).toFixed(2)), parseFloat((keypoints[263].y/img.height).toFixed(2)), parseFloat((keypoints[249].x/img.width).toFixed(2)), parseFloat((keypoints[249].y/img.height).toFixed(2)), parseFloat((keypoints[390].x/img.width).toFixed(2)), parseFloat((keypoints[390].y/img.height).toFixed(2)), parseFloat((keypoints[373].x/img.width).toFixed(2)), parseFloat((keypoints[373].y/img.height).toFixed(2)), parseFloat((keypoints[374].x/img.width).toFixed(2)), parseFloat((keypoints[374].y/img.height).toFixed(2)), parseFloat((keypoints[380].x/img.width).toFixed(2)), parseFloat((keypoints[380].y/img.height).toFixed(2)), parseFloat((keypoints[381].x/img.width).toFixed(2)), parseFloat((keypoints[381].y/img.height).toFixed(2)), parseFloat((keypoints[382].x/img.width).toFixed(2)), parseFloat((keypoints[382].y/img.height).toFixed(2)), parseFloat((keypoints[473].x/img.width).toFixed(2)), parseFloat((keypoints[473].y/img.height).toFixed(2)), parseFloat((keypoints[474].x/img.width).toFixed(2)), parseFloat((keypoints[474].y/img.height).toFixed(2)), parseFloat((keypoints[475].x/img.width).toFixed(2)), parseFloat((keypoints[475].y/img.height).toFixed(2)), parseFloat((keypoints[476].x/img.width).toFixed(2)), parseFloat((keypoints[476].y/img.height).toFixed(2)), parseFloat((keypoints[477].x/img.width).toFixed(2)), parseFloat((keypoints[477].y/img.height).toFixed(2)), ];

        const cb = -1.80441803 ;
        const rb = 1.70189544;
        const lb = -4.32506835;
        const ub = 0.03957106;
        let upvalue = 0;
        let rvalue = 0;
        let lvalue = 0;
        let cvalue =0;
        for(let i = 0; i < upcoeffs.length; i += 1) {
            upvalue = upvalue + upcoeffs[i]*dfeatures[i];
            rvalue = rvalue + rcoeffs[i]*dfeatures[i];
            lvalue = lvalue + lcoeffs[i]*dfeatures[i];
            cvalue = cvalue + cencoeffs[i]*dfeatures[i];
        }

        upvalue = 1/(1+(Math.exp(-1*(upvalue+ ub))));
        rvalue = 1/(1+(Math.exp(-1*(rvalue+ rb))));
        lvalue = 1/(1+(Math.exp(-1*(lvalue+ lb))));
        cvalue = 1/(1+(Math.exp(-1*(cvalue+ cb))));

        if(upvalue === Math.max(upvalue, rvalue, lvalue, cvalue) || upvalue>0.55){
            up = true;
        }
        if(cvalue === Math.max(upvalue, rvalue, lvalue, cvalue) || cvalue>0.65){
            center = true;
        }
        if(rvalue === Math.max(upvalue, rvalue, lvalue, cvalue) || rvalue>0.65){
            right = true;
        }
        if(lvalue === Math.max(upvalue, rvalue, lvalue, cvalue) || lvalue>0.65){
            left = true;
        }

        let rr = (radiusRight * 100 / img.width);
        let rl = (radiusLeft * 100 / img.width);

        if(direction === 0 && center) {
            validations[0] = true;
        } else if(direction === 1 && right) {
            validations[0] = true;
        } else if(direction === 2 && left) {
            validations[0] = true;
        } else if(direction === 3 && up) {
            validations[0] = true;
        }

        // Check distance
        const xbound1 = keypoints[446].x;
        const xbound2 = keypoints[226].x;
        const ybound1 = keypoints[200].y;
        const ybound2 = keypoints[10].y;
        if (xbound1 < img.width && xbound2 >= 0 && ybound1 < img.height && ybound2 >= 0) {
            validations[1] = !(rr < distanceThreshold && rl < distanceThreshold);
        }
        else{
            // It's too close
            validations[1] = false;
        }

        // Check blink
        validations[2] = detectBlink(keypoints);

        //Check eye size
        let eye_size = false;
        const rightEyeL = 362;
        const rightEyeR = 263;
        const leftEyeL = 33;
        const leftEyeR = 133;
        const reyew = Math.abs(keypoints[rightEyeL].x - keypoints[rightEyeR].x);
        const leyew = Math.abs(keypoints[leftEyeL].x - keypoints[leftEyeR].x);
        if(reyew >260 *(img.width/width) && leyew >260*(img.width/width)){
            eye_size = true
        }
        validations[4] = eye_size;

        let left_points = [33, 246, 161, 160, 159, 158, 157, 173, 133, 155, 154, 153, 145, 144, 163, 7];
        let right_points = [362, 398, 384, 385, 386, 387, 388, 466, 263, 249, 390, 373, 374, 380, 381, 382];
        let right_iris = [473, 474, 475, 476, 477];
        let left_iris = [468, 469, 470, 471, 472];
        let two_eye_rec = [8, 372, 197, 143];
        let lc = [];
        let rc = [];
        let right_iris_contour = [];
        let left_iris_contour = [];
        let out_minxs = [];
        let out_minys = [];

        for(let i = 0; i < left_points.length; i += 1) {
            lc.push([keypoints[left_points[i]].x,keypoints[left_points[i]].y]);
        }
        for(let i = 0; i < right_points.length; i += 1) {
            rc.push([keypoints[right_points[i]].x,keypoints[right_points[i]].y]);
        }
        for(let i = 0; i < left_iris.length; i += 1) {
            left_iris_contour.push([keypoints[left_iris[i]].x,keypoints[left_iris[i]].y]);
        }
        for(let i = 0; i < right_iris.length; i += 1) {
            right_iris_contour.push([keypoints[right_iris[i]].x,keypoints[right_iris[i]].y]);
        }
        for(let i = 0; i < two_eye_rec.length; i += 1) {
            const x = keypoints[two_eye_rec[i]].x;
            const y = keypoints[two_eye_rec[i]].y;
            if((x > 0 && x < img.width) && (y > 0 && y < img.height)) validations[5] = true;
            out_minxs.push(x);
            out_minys.push(y);
        }
        
        let out_minx =Math.min(...out_minxs);
        let out_miny =Math.min(...out_minys);

        return {
            validations,
            coordinates: {
                out_minxs,
                out_minys,
                lc,
                rc,
                left_iris_contour,
                right_iris_contour,
                out_minx,
                out_miny,
                large_width: width,
                large_height: height
            }
        };
    } else {
        return {
            validations,
            coordinates: {}
        };
    }
};

const calculateBrightness = (img, leftShape) => {
    let ctx = img.getContext('2d');
    let count = 0, totalR=0, totalG=0, totalB=0, leftAverageR=0, leftAverageB=0, leftAverageG=0, rightAverageR=0, rightAverageB=0, rightAverageG=0;
    let minmax = getMinMax(leftShape);
    let imageData = ctx.getImageData(minmax[0], minmax[1], Math.abs(minmax[2] - minmax[0]),
        Math.abs(minmax[3] - minmax[1])).data;

    for(let i = 0; i < imageData.length; i += 4) {
        const r = imageData[i];
        const g = imageData[i + 1];
        const b = imageData[i + 2];
        totalR += r;
        totalG += g;
        totalB += b;
        count++;
    }

    if (count !== 0) {
        leftAverageR = totalR/count;
        leftAverageG = totalG/count;
        leftAverageB = totalB/count;
    }

    if ((leftAverageR + leftAverageB + leftAverageG) / 3 < 70){
        return false;
    }

    return true;
};

const getMinMax = (data) => {
    function getMinX() {
        return data.reduce((min, p) => p[0] < min ? p[0] : min, data[0][0]);
    }

    function getMaxX() {
        return data.reduce((max, p) => p[0] > max ? p[0] : max, data[0][0]);
    }

    function getMinY() {
        return data.reduce((min, p) => p[1] < min ? p[1] : min, data[0][1]);
    }

    function getMaxY() {
        return data.reduce((max, p) => p[1] > max ? p[1] : max, data[0][1]);
    }

    let minmax = []; // 0 --> MinX, 1 --> MinY, 2 --> MaxX, 3 --> MaxY
    minmax.push(getMinX());
    minmax.push(getMinY());
    minmax.push(getMaxX());
    minmax.push(getMaxY());

    return minmax;
};

const detectBlink = (keypoints) => {
    const rightEyeL = 362;
    const rightEyeR = 263;
    const rightEyeT = 386;
    const rightEyeB = 374;

    const leftEyeL = 33;
    const leftEyeR = 133;
    const leftEyeT = 159;
    const leftEyeB = 145;

    const aL = calculateEuclideanDistance(keypoints[leftEyeT].x, keypoints[leftEyeT].y, keypoints[leftEyeB].x, keypoints[leftEyeB].y);
    const bL = calculateEuclideanDistance(keypoints[leftEyeL].x, keypoints[leftEyeL].y, keypoints[leftEyeR].x, keypoints[leftEyeR].y);

    const aR = calculateEuclideanDistance(keypoints[rightEyeT].x, keypoints[rightEyeT].y, keypoints[rightEyeB].x, keypoints[rightEyeB].y);
    const bR = calculateEuclideanDistance(keypoints[rightEyeL].x, keypoints[rightEyeL].y, keypoints[rightEyeR].x, keypoints[rightEyeR].y);

    const blinkRatio = ((bL / aL) + (bR / aR)) / 2;

    return blinkRatio < 4.2;
};

const calculateEuclideanDistance = (x1, y1, x2, y2) => {
    return Math.sqrt(Math.pow((x1 - x2), 2) + Math.pow((y1 - y2), 2));
};

export default imageValidation;